<!-- Main section IIT2-6607 -->
<section class="main_section sku_compare_page" *ngIf="!isDataLoading">
    <div class="comparable_content d-flex flex-column h-100" id="compareContentDiv">
        <div class="main_section_headers sku_compare_header" id="skuCompareHeader">
            <div class="d-flex align-items-center" id="compareDFlex">
                <img class="sku_compare_icon" alt="SKU Compare icon" />
                <span>{{globalconst.SKU_COMPARE_MAIN_HEADING}}</span>
            </div>
        </div>

        <div class="sectioned_table section_header">
            <div class="sku_id_dropdown">
                <ng-select placement="bottom"
                    [items]="skuList"
                    [placeholder]="searchByNamePlaceholderText" bindLabel="publishedName"
                    name="skuSelect" [clearable]="true" [selectOnTab]="true"
                    [notFoundText]='globalconst.NO_DATA_FOUND'               
                    (change)="onChangeSKU($event)" [searchFn]="SKUSearchFn">
                    <ng-template ng-option-tmp let-item="item" let-index="index">
                        <div><strong>{{item?.publishedName}}</strong></div>
                        {{item?.internalName}}
                    </ng-template>
                </ng-select> 
                <div *ngIf="!allSkuList.length" class="search-icon"></div>
            </div>                   
        </div>

        <div class="sectioned_table" *ngIf="allSkuList?.length && allSkuList?.length > 0"
            id="sectionTable">
            <table class="table" cell-padding="10" cell-spacing="10" aria-describedby="SKU comparison table">
                <thead>
                    <tr>
                        <th scope="col">
                            <div class="cell_title" id="skuComparisonBase">{{globalconst.SKU_COMPARISON_BASE_SKU}}</div>
                            <div id="skuComparisonName"> {{globalconst.SKU_COMPARISON_NAME}}</div>
                        </th>
                        <th scope="col">
                            <div class="cell_title" id="sku2ComparisonBase">{{globalconst.SKU_COMPARISON_SKU2}}</div>
                            <div id="sku2ComapareCmpText">{{globalconst.SKU_COMPARE_CMPTEXT}}</div>
                        </th>
                        <th scope="col">
                            <div class="cell_title" id="sku3ComparisonBase">{{globalconst.SKU_COMPARISON_SKU3}}</div>
                            <div id="sku3CompareCmpText">{{globalconst.SKU_COMPARE_CMPTEXT}}</div>
                        </th>
                        <th scope="col">
                            <div class="cell_title" id="sku4CaomparisonBase"> {{globalconst.SKU_COMPARISON_SKU4}} </div>
                            <div id="sku4CompareCmpText">{{globalconst.SKU_COMPARE_CMPTEXT}}</div>
                        </th>
                        <th scope="col">
                            <div class="cell_title" id="sku5ComparisoBase">{{globalconst.SKU_COMPARISON_SKU5}}</div>
                            <div id="sku5CompareCmptext">{{globalconst.SKU_COMPARE_CMPTEXT}}</div>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let eachSKU of allSkuList; let i = index">
                        <ng-template #publishInternalTooltip>
                            <div>
                                <span>{{eachSKU?.publishedName}},</span><br />
                                <span>{{eachSKU?.internalName}}</span>
                            </div>
                        </ng-template>
                        <td [ngbTooltip]="eachSKU?.internalName?.length > 25 || eachSKU?.publishedName?.length > 25 ? publishInternalTooltip : ''">
                            <div class="cell_title" id="skuID">{{eachSKU?.publishedName}}<span
                                    *ngIf="eachSKU?.internalName">,</span></div>
                            <div class="internal-cell" id="skuInteralName">{{eachSKU?.internalName}}</div>
                        </td>
                        <td>
                            <ng-select placement="bottom"
                                [ngClass]="{'errorColor': selectedItem[eachSKU?.skuID].duplicateFlag?.sku2}"
                                [items]="eachSKU?.filterSKUData"
                                placeholder="{{globalconst.SKU_COMPARISON_DRPDWN_SELECTION}}" bindLabel="publishedName"
                                bindValue="publishedName" name="skuSelect" [clearable]="true" [selectOnTab]="true"
                                [compareWith]="compareWith" [notFoundText]='globalconst.NO_DATA_FOUND'
                                [(ngModel)]="selectedItem[eachSKU?.skuID].sku2" [ngModelOptions]="{standalone: true}"
                                (change)="onSKUChange($event,eachSKU?.skuID,'sku2')" [searchFn]="SKUSearchFn">
                                <ng-template ng-option-tmp let-item="item" let-index="index">
                                    <div><strong>{{item?.publishedName}}</strong></div>
                                    {{item?.internalName}}
                                </ng-template>
                            </ng-select>
                        </td>
                        <td>
                            <ng-select placement="bottom"
                                [ngClass]="{'errorColor': selectedItem[eachSKU?.skuID].duplicateFlag?.sku3}"
                                [items]="eachSKU?.filterSKUData"
                                placeholder="{{globalconst.SKU_COMPARISON_DRPDWN_SELECTION}}" bindLabel="publishedName"
                                bindValue="publishedName" name="skuSelect" [clearable]="true" [selectOnTab]="true"
                                [compareWith]="compareWith" [notFoundText]='globalconst.NO_DATA_FOUND'
                                [(ngModel)]="selectedItem[eachSKU?.skuID].sku3" [ngModelOptions]="{standalone: true}"
                                (change)="onSKUChange($event,eachSKU?.skuID,'sku3')" [searchFn]="SKUSearchFn">
                                <ng-template ng-option-tmp let-item="item" let-index="index">
                                    <div><strong>{{item?.publishedName}}</strong></div>
                                    {{item?.internalName}}
                                </ng-template>
                            </ng-select>
                        </td>
                        <td>
                            <ng-select placement="bottom"
                                [ngClass]="{'errorColor': selectedItem[eachSKU?.skuID].duplicateFlag?.sku4}"
                                [items]="eachSKU?.filterSKUData"
                                placeholder="{{globalconst.SKU_COMPARISON_DRPDWN_SELECTION}}" bindLabel="publishedName"
                                bindValue="publishedName" name="skuSelect" [clearable]="true" [selectOnTab]="true"
                                [compareWith]="compareWith" [notFoundText]='globalconst.NO_DATA_FOUND'
                                [(ngModel)]="selectedItem[eachSKU?.skuID].sku4" [ngModelOptions]="{standalone: true}"
                                (change)="onSKUChange($event,eachSKU?.skuID,'sku4')" [searchFn]="SKUSearchFn">
                                <ng-template ng-option-tmp let-item="item" let-index="index">
                                    <div><strong>{{item?.publishedName}}</strong></div>
                                    {{item?.internalName}}
                                </ng-template>
                            </ng-select>
                        </td>
                        <td>
                            <ng-select placement="bottom"
                                [ngClass]="{'errorColor': selectedItem[eachSKU?.skuID].duplicateFlag?.sku5}"
                                [items]="eachSKU?.filterSKUData"
                                placeholder="{{globalconst.SKU_COMPARISON_DRPDWN_SELECTION}}" bindLabel="publishedName"
                                bindValue="publishedName" name="skuSelect" [clearable]="true" [selectOnTab]="true"
                                [compareWith]="compareWith" [notFoundText]='globalconst.NO_DATA_FOUND'
                                [(ngModel)]="selectedItem[eachSKU?.skuID].sku5" [ngModelOptions]="{standalone: true}"
                                (change)="onSKUChange($event,eachSKU?.skuID,'sku5')" [searchFn]="SKUSearchFn">
                                <ng-template ng-option-tmp let-item="item" let-index="index">
                                    <div><strong>{{item?.publishedName}}</strong></div>
                                    {{item?.internalName}}
                                </ng-template>
                            </ng-select>
                        </td>
                    </tr>
                </tbody>
                <div class="mt-5"></div>
            </table>
        </div>

        <div class="NoDataDiv" *ngIf="allSkuLists?.length < 2">
            <span>{{globalconst.COMPARE_SKU_TEXT}}</span> <!--TODO CHANGEIT-->
        </div>

    </div>
    <footer>
        <div *ngIf="showDuplicatesError" class="dupCls">
            <span class="errDuplicateTxt">{{globalconst.SKU_DUPLICATE_ERR_TXT}}</span>
        </div>
        <div class="button_wrapper " style="justify-content: flex-end"
            *ngIf="allSkuList?.length && allSkuList?.length > 0" id="btnWrapper">
            <button type="button" class="btn btn-outline-primary btn-lg" (click)="revertChanges()" [disabled]= "allSkuList?.length === 1">{{globalconst.CANCEL}}</button>
            <button type="button" class="btn btn-primary btn-lg" [disabled]= "allSkuList?.length === 1" (click)="saveChanges()">{{globalconst.SAVE_CHANGES}}</button>
        </div>
    </footer>
</section>
<!-- 
TODO - resolved spinner issue SKUID component     -->
<iposcen-spinner-overlay *ngIf="isDataLoading"></iposcen-spinner-overlay>